import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Disponible",           icon: "fas fa-tasks", color: "#10b981", bg: "#f0fdf4", href: "/ListadoDisponible",         desc: "Disponible general",       permOr: ["menu_disponible", "menu_disponibleIciqlo", "menu_disponibleV1per"] },
  { label: "Disponible Vendedor",  icon: "fas fa-tasks", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoDisponibleVendedor", desc: "Disponible por vendedor",   perm: "disponible_vendedores" },
  { label: "Acumulado Mensual",    icon: "fas fa-tasks", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoAcumuladoMesnual",   desc: "Acumulado por mes",         perm: "menu_disponible" },
  { label: "Disponible MP",        icon: "fas fa-tasks", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoDisponibleMP",       desc: "Disponible marketplace",    perm: "menu_disponible" },
];

function BotonesDisponibles() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-tasks" color="#10b981" bg="#f0fdf4" title="Inventario Disponible" subtitle="Stock disponible por segmento" />
        {user.menu_inventarios ? (
          <div className="row">
            {ITEMS.map((r, i) => {
              const enabled = r.permOr ? r.permOr.some((p) => !!user[p]) : !!user[r.perm];
              return <MenuCard key={i} {...r} enabled={enabled} />;
            })}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesDisponibles;
